import eventsRoutes from './events'

export default [...eventsRoutes]
